export class GetReport {
  static readonly type = '[Report] Get report for period';
  constructor(
    public fromDate: Date,
    public toDate: Date
  ) {}
}
